import { render, staticRenderFns } from "./ClientStatusTypes.vue?vue&type=template&id=65f90525&"
import script from "./ClientStatusTypes.vue?vue&type=script&lang=js&"
export * from "./ClientStatusTypes.vue?vue&type=script&lang=js&"
import style0 from "./ClientStatusTypes.vue?vue&type=style&index=0&id=65f90525&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports